export default __webpack_public_path__ + "static/media/EpitettTermeszetiOrokseg.8c827f61.jpg";